import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

App.mpType = 'app'

// 引入全局uView
import uView from 'uview-ui'
Vue.use(uView);

// 引入全局状态管理
import store from './store/index.js'
Vue.prototype.$store = store

store.dispatch('getHeight')

Vue.prototype.$baseUrl = 'https://ditan.hflxkj.top/stall/api';

const app = new Vue({
	store,
    ...App
})

app.$mount()